import React from 'react';
import {
  Box,
  Typography,
  Button,
  Paper,
  Container,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const Home: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 8 }}>
        <Paper
          elevation={0}
          sx={{
            p: 6,
            textAlign: 'center',
            background: `linear-gradient(135deg, ${theme.palette.primary.light}15 0%, ${theme.palette.secondary.light}15 100%)`,
            borderRadius: 4,
            mb: 8,
          }}
        >
          <Typography
            variant="h2"
            component="h1"
            gutterBottom
            color="primary"
            sx={{ fontWeight: 700 }}
          >
            {t('home.title')}
          </Typography>
          <Typography
            variant="h5"
            color="text.secondary"
            paragraph
            sx={{ mb: 4, maxWidth: '800px', mx: 'auto' }}
          >
            {t('home.subtitle')}
          </Typography>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/contact')}
            sx={{
              px: 4,
              py: 1.5,
              background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.secondary.main} 90%)`,
              color: 'white',
              '&:hover': {
                background: `linear-gradient(45deg, ${theme.palette.primary.dark} 30%, ${theme.palette.secondary.dark} 90%)`,
              },
            }}
          >
            {t('home.cta')}
          </Button>
        </Paper>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              md: 'repeat(3, 1fr)',
            },
            gap: 4,
          }}
        >
          {['prints', 'turnaround', 'support'].map((service, index) => (
            <Paper
              key={service}
              elevation={0}
              sx={{
                p: 4,
                textAlign: 'center',
                background: `linear-gradient(135deg, ${theme.palette.primary.light}10 0%, ${theme.palette.secondary.light}10 100%)`,
                borderRadius: 4,
                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
                  background: `linear-gradient(135deg, ${theme.palette.primary.light}20 0%, ${theme.palette.secondary.light}20 100%)`,
                },
              }}
            >
              <Typography
                variant="h5"
                component="h2"
                gutterBottom
                color="primary"
                sx={{ fontWeight: 600 }}
              >
                {t(`home.services.${service}.title`)}
              </Typography>
              <Typography color="text.secondary">
                {t(`home.services.${service}.description`)}
              </Typography>
            </Paper>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default Home; 